import React from "react";
import "./Introduction.css";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
// import { ThemeContext } from "../../Context/theme";

export const Introduction = () => {
  //  const [{ themename }] = React.useContext(ThemeContext);

  return (
    <div id="about">
      <section className="about section">
        <div data-aos="fade-right" id="tech">
          <h2 className="about section__title">
            About<span className="different">ME</span>
          </h2>
          <div className={"introduction "}>
            <div className="introduction_logocontainer ">
              <img
                src="https://avatars.githubusercontent.com/u/84439829?s=400&u=f0851008898135bf529d9ca8280ad10f51e9e524&v=4"
                alt="https://imgur.com/a/eqvJAHA"
                className="home-img"
              />
            </div>
            <div className="introduction_datacontainer">
              <h4>
                Hi Everyone, I am{" "}
                <span className="different" id="user-detail-name">
                  Aditi Sharma{" "}
                </span>{" "}
                from{" "}
                <span
                  className="different about section"
                  id="user-detail-intro"
                >
                  {" "}
                  Himachal
                </span>
                . I have completed my graduation in Bachelor of Science (Hons)
                Mathematics from University of Delhi.
              </h4>
              <h4>Some of my interests apart form Coding :</h4>
              <h4 className="different">
                <span className="icons">
                  <ExitToAppIcon />
                </span>
                Listening Classical Music
              </h4>
              <h4 className="different">
                <span className="icons">
                  <ExitToAppIcon />
                </span>
                Watching Movies
              </h4>
              <h4 className="different">
                <span className="icons">
                  <ExitToAppIcon />
                </span>
                Reading
              </h4>
              <h4 className="different">
                <span className="icons">
                  <ExitToAppIcon />
                </span>
                Travelling{" "}
              </h4>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
